import React from 'react'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import InputAdornment from '@mui/material/InputAdornment'

import moment from 'moment-timezone'

import { isLoggedIn, setUser } from '../services/auth'

// La fecha viene del backend con sufijo Z, pero el valor ya está en hora local
// de Guatemala (no es UTC real). Por eso se formatea tal cual, sin convertir
// zona horaria, en formato YYYY-MM-DD HH:mm.
export const formatDateGuatemala = date => {
  if (!date) return ''
  const m = moment.utc(date)
  return m.isValid() ? m.format('YYYY-MM-DD HH:mm') : ''
}

export const generateAddContactSchema = (sendableCountries, contact) => {
  const countries = sendableCountries.map(c => {
    return {
      id: c.id,
      iconUrl: c.flagImgURL,
      value: c.id,
      text: `+${c.callingCode}`,
    }
  })

  return [
    {
      id: 'countryId',
      component: TextField,
      startAdornmentValues: countries,
      value: contact.country.id,
      componentProps: {
        select: true,
        label: 'Telefono',
        required: true,
        InputLabelProps: {
          shrink: true,
        },
        InputProps: {
          startAdornment: (
            <InputAdornment position="start">
              <img
                src={contact.country.flagImgURL}
                alt="country-flag"
                style={{ width: '100%', maxWidth: '50px' }}
              />
            </InputAdornment>
          ),
        },
        defaultValue: contact.country.id,
        style: { maxWidth: '100px', minWidth: '100px' },
      },
      children: countries.map(country => (
        <MenuItem key={country.id} value={country.value}>
          {country.text}
        </MenuItem>
      )),
    },
  ]
}

export const generateGroupedContacts = contacts => {
  return contacts.reduce(
    (grouped, contactResponse) => {
      grouped.contacts = [...grouped.contacts, ...contactResponse.contacts]
      grouped.groups = [...grouped.groups, contactResponse.id]
      grouped.groupCounts = [
        ...grouped.groupCounts,
        contactResponse.contacts.length,
      ]
      return grouped
    },
    {
      contacts: [],
      groups: [],
      groupCounts: [],
    },
  )
}

export const addVoucherToCart = (voucher, quantity) => {
  const voucherInput = {
    id: voucher.id,
    name: voucher.name || voucher.shortName,
    brand:
      voucher.partnerPushMoney.commercialName ||
      voucher.partnerPushMoney.legalName,
    amount: voucher.localAmount,
    localAmount: voucher.calculatedPrice,
    quantity,
    discountAmount: voucher.discountPrice ? voucher.discountPrice : 0,
  }

  return [voucherInput]
}

export const addFormattedVoucherToCart = voucher => {
  return [
    Object.keys(voucher).reduce((v, key) => {
      if (!['primaryImgURL'].includes(key)) {
        v[key] = voucher[key]
      }

      return v
    }, {}),
  ]
}

export const checkUserOrCreateAnonymousUser = async createAnonymousUser => {
  const isLogged = isLoggedIn()
  if (!isLogged) {
    const {
      data: { createAnonymousUser: user },
    } = await createAnonymousUser()
    setUser({ token: user.token, user: user.user })
  }
  return true
}

export const convertDate = date => {
  var newDate = ''
  if (date) {
    if (date.indexOf('T') > -1) {
      newDate = date.split('T')[0]
    } else {
      newDate = date.split(' ')[0]
    }
    return newDate || ''
  }
}

export const formatDateForExpiration = date => {
  if (date) {
    const dateObj = date.split(' ')
    const dateObj2 = dateObj[0].split('-')
    const day = dateObj2[2].split('T')
    const meses = [
      'ene',
      'feb',
      'mar',
      'abr',
      'may',
      'jun',
      'jul',
      'ago',
      'sep',
      'oct',
      'nov',
      'dic',
    ]

    const monthName = meses[parseInt(dateObj2[1]) - 1]
    const fechaIphone = `${day[0]}/${monthName}/${dateObj2[0]}`
    return fechaIphone
  } else {
    return ''
  }
}

export const formatDate = date => {
  try {
    const fecha = new Date(date)
    const day = fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
    const month =
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    const year = fecha.getFullYear()
    return `${day}/${month}/${year}`
  } catch (error) {
    return ''
  }
}
export const formatDateInit = date => {
  try {
    const fecha = new Date(date)
    const day = fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
    const month =
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    const year = fecha.getFullYear()
    return `${year}-${month}-${day}`
  } catch (error) {
    return ''
  }
}
export const formatDateHours = date => {
  try {
    const fecha = new Date(date)
    const day = fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
    const month =
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    const year = fecha.getFullYear()
    const hours =
      fecha.getHours() < 10 ? `0${fecha.getHours()}` : fecha.getHours()
    const min =
      fecha.getMinutes() < 10 ? `0${fecha.getMinutes()}` : fecha.getMinutes()
    return `${year}-${month}-${day}T${hours}:${min}`
  } catch (error) {
    return ''
  }
}
export const dateFormatWithHours = date => {
  // AAAA-MMM-DD hh:mm
  try {
    const fecha = new Date(date)
    const day = fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
    const month =
      fecha.getMonth() + 1 < 10
        ? `0${fecha.getMonth() + 1}`
        : fecha.getMonth() + 1
    const year = fecha.getFullYear()
    const hours =
      fecha.getHours() < 10 ? `0${fecha.getHours()}` : fecha.getHours()
    const min =
      fecha.getMinutes() < 10 ? `0${fecha.getMinutes()}` : fecha.getMinutes()
    return `${year}-${month}-${day} ${hours}:${min}`
  } catch (error) {
    return ''
  }
}
// Los movimientos llegan como instante UTC; se muestran en hora de Guatemala (UTC-6, sin DST)
export const dateFormatWithHoursGuatemala = date => {
  const fecha = moment.utc(date).utcOffset(-6)
  return fecha.isValid() ? fecha.format('YYYY-MM-DD HH:mm') : ''
}

export const moneyMask = (number = 0, removeDecimals = false) => {
  const decimals = 2
  try {
    const roundedNumber = parseFloat(number)
    if (!isNaN(roundedNumber)) {
      let formattedNumber = parseFloat(roundedNumber)
        .toFixed(decimals)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

      if (removeDecimals) {
        if (formattedNumber.endsWith('.00')) {
          formattedNumber = formattedNumber.slice(0, -3)
        } else if (formattedNumber.endsWith('.0')) {
          formattedNumber = formattedNumber.slice(0, -2)
        }
      }

      return formattedNumber
    } else {
      return number || ''
    }
  } catch (error) {
    return number || ''
  }
}

export const numberMask = number => {
  try {
    if (!isNaN(number) && !isNaN(Number('' + number))) {
      return ('' + number).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    } else {
      return 0
    }
  } catch (error) {
    console.error('Error formatting number:', error)
    return number
  }
}

export const validarText = valor => {
  if (
    valor === undefined ||
    valor === 'undefined' ||
    valor === null ||
    valor === '' ||
    valor === 'null' ||
    valor <= 0
  ) {
    return false
  } else {
    return true
  }
}
export const validarNumero = valor => {
  const numbers = new RegExp('^[-+]?[0-9]*.?[0-9]*.')
  if (
    isNaN(valor) === true ||
    valor === 'NaN' ||
    valor <= 0.0 ||
    valor === undefined ||
    valor === null ||
    valor === '' ||
    valor === 'null' ||
    valor === 'undefined' ||
    !numbers.test(valor.toString())
  ) {
    return false
  } else {
    return true
  }
}

export const formatDateExcelTopup = fechaOriginal => {
  try {
    const partesFecha = fechaOriginal.split('-')
    const dia = partesFecha[0]
    const mes = partesFecha[1]
    const año = partesFecha[2]
    const fechaFormateada = año + '-' + mes + '-' + dia
    return fechaFormateada
  } catch (error) {
    console.error(error)
  }
  return null
}

export const formatHourExcelTopup = numero => {
  try {
    if (numero < 0 || numero > 1) {
      throw new Error('El número de Excel debe estar entre 0 y 1')
    }
    const horas = Math.floor(numero * 24)
    const minutos = Math.round((numero * 24 - horas) * 60)

    const strHora = `${String(horas).padStart(2, '0')}:${String(
      minutos,
    ).padStart(2, '0')}`
    return strHora
  } catch (error) {
    console.error('Error al formatear la hora desde Excel:', error.message)
    return null
  }
}

export const validateDateTopup = date => {
  if (validarText(date)) {
    const isValidDate = Date.parse(date)
    if (isNaN(isValidDate)) {
      return false
    } else if (new Date().getTime() > new Date(date).getTime()) {
      return false
    }
  } else {
    return false
  }
  return true
}

export const hasPermission = (
  appRoutes,
  exclusiveRoutes = [],
  location,
  routingMarketPlace,
) => {
  let hasPermission = false
  const adminLoginUser = localStorage.getItem('adminLoginUser')

  if (adminLoginUser) {
    const userLogged = JSON.parse(adminLoginUser)
    const adminRol = userLogged?.user?.id_rol

    if (adminRol) {
      // AD-5971: se recalcula siempre. El cache en localStorage nunca se
      // invalidaba, así que al agregar una ruta nueva al menú, las sesiones
      // existentes quedaban bloqueadas (redirect a login) hasta limpiarlo.
      const filteredRoutes = appRoutes.filter(route =>
        route.roles.includes(adminRol),
      )
      localStorage.setItem('filteredRoutes', JSON.stringify(filteredRoutes))

      const pathname = location.pathname.toLowerCase().trim()

      const visitedRoutes = new Set(
        JSON.parse(localStorage.getItem('visitedRoutes')) || [],
      )
      if (isPathInArray(pathname, visitedRoutes)) {
        hasPermission = true
      }

      if (pathname.includes(exclusiveRoutes)) {
        hasPermission = true
      } else {
        hasPermission = filteredRoutes.some(route => {
          if (route.child) {
            return route.child.some(child =>
              pathname
                .toLowerCase()
                .trim()
                .includes(child.path),
            )
          } else {
            return pathname
              .toLowerCase()
              .trim()
              .includes(route.path)
          }
        })
      }
      if (isPathInArray(pathname, routingMarketPlace)) {
        hasPermission = true
      }
      if (hasPermission) {
        visitedRoutes.add(pathname)
        localStorage.setItem(
          'visitedRoutes',
          JSON.stringify(Array.from(visitedRoutes)),
        )
      }
    }

    return hasPermission
  }

  return false
}
export const isPathInArray = (pathname, array) => {
  for (const route of array) {
    if (pathname.startsWith(route)) {
      return true
    }
  }
  return false
}

export const invalidFlags = [
  1,
  3,
  5,
  6,
  9,
  10,
  11,
  12,
  13,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  26,
]

export const formatDatePM = date => {
  try {
    date = date.split('-').join('/')
    const fecha = new Date(date)
    if (fecha) {
      const day = fecha.getDate() < 10 ? `0${fecha.getDate()}` : fecha.getDate()
      const month =
        fecha.getMonth() + 1 < 10
          ? `0${fecha.getMonth() + 1}`
          : fecha.getMonth() + 1
      const year = fecha.getFullYear()
      return `${day}/${month}/${year}`
    } else {
      let arrDate = ''
      const dateObj = date.split(' ')
      if (dateObj[0].split('-').length > 1) {
        arrDate = dateObj[0].split('-')
      } else if (dateObj[0].split('/').length > 1) {
        arrDate = dateObj[0].split('/')
      }
      const dateObj2 = arrDate
      const fechaIphone = `${dateObj2[2]}/${dateObj2[1]}/${dateObj2[0]}`
      return fechaIphone
    }
  } catch (error) {
    return ''
  }
}

export const getIpPublic = async () => {
  try {
    const ipPublic = await fetchIpPublic()
    return ipPublic
  } catch (error) {
    console.error('Error al obtener la dirección IP pública:', error)
    return ''
  }
}

const fetchIpPublic = async () => {
  try {
    const response = await fetch('https://api64.ipify.org/?format=json', {
      method: 'GET',
      timeout: 5000,
    })
    if (!response.ok) {
      return ''
    }
    const data = await response.json()
    return data?.ip
  } catch (e) {
    return e
  }
}

/**
 * Recupera y convierte un objeto JSON desde localStorage.
 *
 * @param {string} key - La clave del elemento a recuperar de localStorage.
 * @returns {Object|null} - El objeto parseado si es un JSON válido; de lo contrario, null.
 *
 * La función intenta obtener un elemento en formato JSON desde localStorage según la clave especificada.
 * Si la conversión falla o el elemento no existe, registra un error y devuelve null.
 */
export const getToStorage = key => {
  try {
    if (typeof window !== 'undefined') {
      const stored = window.localStorage.getItem(key)
      return stored ? JSON.parse(stored) : null
    }
  } catch (error) {
    console.error(`Error parsing ${key} from localStorage:`, error)
    return null
  }
  return null
}

export const parseEnvFields = envValue => {
  if (!envValue || envValue.trim() === '') {
    console.warn('Environment variable is empty. Using default fields.')
    return []
  }
  return envValue.split(',').map(field => field.trim())
}
